module.exports = __webpack_public_path__ + "static/media/jeff.837e09ed.png";